/**
 * Why Raw Milkman – Tabs component
 * Handles tab switching and Shopify editor block:select events.
 */
if (!customElements.get('why-raw-milkman-tabs')) {
  class WhyRawMilkmanTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.panels = [];
    }

    connectedCallback() {
      this.buttons = [...this.querySelectorAll('.wrm-tabs__button')];
      this.panels = [...this.querySelectorAll('.wrm-tabs__panel')];

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.switchTab(btn));
      });

      // Keyboard support: Arrow keys to move between tabs
      this.querySelector('.wrm-tabs__buttons')?.addEventListener('keydown', (e) => {
        this.handleKeydown(e);
      });

      // Shopify editor support
      this.handleEditorEvents();
    }

    switchTab(activeBtn) {
      const targetId = activeBtn.getAttribute('aria-controls');

      // Update buttons
      this.buttons.forEach((btn) => {
        btn.classList.remove('wrm-tabs__button--active');
        btn.setAttribute('aria-selected', 'false');
      });
      activeBtn.classList.add('wrm-tabs__button--active');
      activeBtn.setAttribute('aria-selected', 'true');

      // Update panels
      this.panels.forEach((panel) => {
        panel.classList.remove('wrm-tabs__panel--active');
        panel.setAttribute('hidden', '');
      });

      const targetPanel = this.querySelector(`#${targetId}`);
      if (targetPanel) {
        targetPanel.classList.add('wrm-tabs__panel--active');
        targetPanel.removeAttribute('hidden');
      }
    }

    handleKeydown(e) {
      const currentIndex = this.buttons.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let newIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        newIndex = (currentIndex + 1) % this.buttons.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        newIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        newIndex = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        newIndex = this.buttons.length - 1;
      }

      if (newIndex !== undefined) {
        this.buttons[newIndex].focus();
        this.switchTab(this.buttons[newIndex]);
      }
    }

    handleEditorEvents() {
      if (!window.Shopify?.designMode) return;

      document.addEventListener('shopify:block:select', (e) => {
        const sectionId = this.dataset.sectionId;
        if (e.detail.sectionId !== sectionId) return;

        const blockId = e.detail.blockId;
        const btn = this.buttons.find((b) => b.dataset.blockId === blockId);
        if (btn) this.switchTab(btn);
      });
    }
  }

  customElements.define('why-raw-milkman-tabs', WhyRawMilkmanTabs);
}
